import React, { Component } from 'react';
import classNames from 'classnames';
import { AppTopbar } from '../AppTopbar';
import { AppBreadcrumb } from "../AppBreadcrumb";
import { AppFooter } from '../AppFooter';
import { Route } from 'react-router-dom'
import { Dashboard } from '../components/Dashboard';
import { FormsDemo } from '../components/FormsDemo';
import { SampleDemo } from '../components/SampleDemo';
import { DataDemo } from '../components/DataDemo';
import { PanelsDemo } from '../components/PanelsDemo';
import { OverlaysDemo } from '../components/OverlaysDemo';
import { MenusDemo } from '../components/MenusDemo';
import { MessagesDemo } from '../components/MessagesDemo';
import { ChartsDemo } from '../components/ChartsDemo';
import { MiscDemo } from '../components/MiscDemo';
import { EmptyPage } from '../components/EmptyPage';
import { UtilsDemo } from '../components/UtilsDemo';
import { Documentation } from '../components/Documentation';
import { withRouter } from 'react-router';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import 'primereact/resources/primereact.min.css';
import 'primeflex/primeflex.css';
import '../ripple.js';
import '../App.css';
import { AppConfig } from "../AppConfig";
import { Cfdi } from './Cfdi';
import { Usuario } from './Usuario';
import { Trabajador } from './Trabajador';
import { SubirCfdi } from './SubirCfdi';
import { SubirAfil } from './SubirAfil';
import { Expediente } from './Expediente';
import DetalleDocumentos from './DetalleDocumentos';
import { ConsultaReciboTrabajador } from './ConsultaReciboTrabajador';
import { DetalleRecibos } from './DetalleRecibos';
import { Cliente } from './Cliente';
import { DetalleAfil } from './DetalleAfil';
import servicioUsuario from '../servicios/ServicioUsuario';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioObjetos from '../servicios/ServicioObjetos';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Password } from 'primereact/password';
import { Growl } from 'primereact/growl';
import { AltaImss } from './AltaImss';
import { ConsultarArchivosTrabajador } from './ConsultarArchivosTrabajador';
import menuServices from '../servicios/MenuServices';
import Recaptcha from 'react-recaptcha';
import { AdministradorUsuario } from './AdministradorUsuario';
class AppRespaldoOriginal extends Component {

	constructor() {
		super();
		this.state = {
			horizontal: true,
			topbarSize: 'large',
			topbarColor: 'layout-topbar-materialone',
			menuColor: 'layout-menu-light',
			layoutColor: 'materialone',
			themeColor: 'materialone',
			menuActive: false,
			configDialogActive: false,

			usuario: {},
			trabajador: {},
			wrapperUsuario: {},
			mostrarModalContrasenia: false,
			mostrarModalMensaje: false,
			confirma: null,
			errores: {},
			validarBotonEnvio: true,
			menu: [],
			verificaCapchap: false,
			logo: '',
			fondo: '',
			color: ''
		};

		this.onWrapperClick = this.onWrapperClick.bind(this);
		this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
		this.onTopbarUserMenuButtonClick = this.onTopbarUserMenuButtonClick.bind(this);
		this.onTopbarUserMenuClick = this.onTopbarUserMenuClick.bind(this);
		this.onRootMenuItemClick = this.onRootMenuItemClick.bind(this);
		this.onMenuItemClick = this.onMenuItemClick.bind(this);
		this.onSidebarClick = this.onSidebarClick.bind(this);
		this.changeTopbarTheme = this.changeTopbarTheme.bind(this);
		this.changeTopbarSize = this.changeTopbarSize.bind(this);
		this.changeMenuToHorizontal = this.changeMenuToHorizontal.bind(this);
		this.changeMenuTheme = this.changeMenuTheme.bind(this);
		this.changeComponentTheme = this.changeComponentTheme.bind(this);
		this.changePrimaryColor = this.changePrimaryColor.bind(this);
		this.onToggleBlockBodyScroll = this.onToggleBlockBodyScroll.bind(this);
		this.isHorizontalMenuActive = this.isHorizontalMenuActive.bind(this);
		this.enviarCodigo = this.enviarCodigo.bind(this);
		this.recaptchaLoad = this.recaptchaLoad.bind(this);
		this.verificaCapchaCorrecto = this.verificaCapchaCorrecto.bind(this);
		this.cambiarColorComponentes = this.cambiarColorComponentes.bind(this);
		this.createMenu();

	}
	componentDidMount() {
		this.validaEstatusUsuario();


	}
	recaptchaLoad() {
		console.log("captchap");
	}
	verificaCapchaCorrecto(response) {
		if (response) {
			this.setState({
				verificaCapchap: true
			});
		}
	}
	validaEstatusUsuario() {

		servicioUsuario.cambiaContrasena().then((response) => {
			
			// if (!servicioObjetos.esObjetoVacio(response.data.objeto.tcCliente)) {
			// 	this.setState({ topbarColor: 'layout-topbar-' + 'pine', logo: response.data.objeto.tcCliente.logo, fondo: response.data.objeto.tcCliente.fondo, color: response.data.objeto.tcCliente.color });
			// } else {
			// 	this.setState({ topbarColor: 'layout-topbar-' + 'materialone', logo: null, color: null });
			// }
			this.setState({ topbarColor: 'layout-topbar-' + 'materialone', logo: null, color: null });
			this.cambiarColorComponentes();

			if (response.data.error === true)
				window.location = "/consultareciboquadrum"

			if (response.data.mensaje.includes("0"))
				this.setState({ usuario: response.data.objeto, mostrarModalContrasenia: true });


			if (response.data.mensaje.includes("2")) {
				this.setState({ mostrarModalMensaje: true });
				window.setTimeout(() => {
					window.location = "/consultareciboquadrum"
				}, 10000)
			}


		}).catch((error) => {
			if (error)
				window.location = "/consultareciboquadrum"
		});
	}
	asignarValores = (event) => {
		servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
	}
	validarCorreo(usuario) {
		const errores = {};
		var expreReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		var validacionCorreo = expreReg.exec(usuario.correo);
		if (!usuario.correo)
			errores.correo = "El correo es requerido";
		if (!validacionCorreo)
			errores.correo = "El correo no es valido";
		return errores;
	}

	validarCambioContrasena(usuario, confirma, trabajador) {

		const errores = {};

		var expreReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		var validacionCorreo = expreReg.exec(usuario.correo);



		if (!usuario.contrasena)
			errores.contrasena = "El campo es requerido";
		if (!confirma)
			errores.confirma = "El campo es requerido";
		if (confirma !== usuario.contrasena)
			errores.contrasena = "Las constraseñas no coinciden";
		if (!trabajador.rfc)
			errores.trabajador = "El rfc es requerido";
		if (!usuario.correo)
			errores.correo = "El correo es requerido";
		if (!validacionCorreo)
			errores.correo = "El correo no es valido";
		if (!trabajador.curp)
			errores.curp = "La curp es requerida";
		if (!trabajador.numeroSeguroSocial)
			errores.numeroSeguroSocial = "El numero de seguro social es requerido";
		if (!usuario.codigo)
			errores.codigo = "El código es requerido";

		return errores;
	}

	cambiarContrasena() {
		let { usuario, confirma, trabajador, wrapperUsuario, verificaCapchap } = this.state;

		const resultadoValidacion = this.validarCambioContrasena(usuario, confirma, trabajador);
		this.setState({ errores: resultadoValidacion });

		if (!Object.keys(resultadoValidacion).length) {
			if (verificaCapchap == true) {
				wrapperUsuario.ttUsuario = usuario;
				wrapperUsuario.tcTrabajador = trabajador;
				servicioUsuario.actualizarContrasena(wrapperUsuario).then((response) => {

					this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

					if (response.data.error === false)
						this.resetEstados();

				}).catch((error) => { });
			} else {
				this.growl.show({ severity: 'error', summary: 'Error', detail: 'Falta el captchap' });
			}

		}

	}

	resetEstados() {
		this.setState({ usuario: {}, wrapperUsuario: {}, trabajador: {}, mostrarModalContrasenia: false, mostrarModalMensaje: false, confirma: null, errores: {} })
	}
	enviarCodigo() {
		let { usuario, validarBotonEnvio } = this.state;
		const resultadoValidacion = this.validarCorreo(usuario);
		this.setState({ errores: resultadoValidacion });

		if (!Object.keys(resultadoValidacion).length) {
			servicioUsuario.enviarCodigo(usuario).then((response) => {

				this.setState({ validarBotonEnvio: false });
				console.log(validarBotonEnvio);
				this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });




			}).catch((error) => { });
		}
	}
	cerrarSession() {
		this.setState({ mostrarModalContrasenia: false });
		localStorage.removeItem("auth");
		window.location = '/consultareciboquadrum';



	}

	onWrapperClick(event) {
		if (!this.menuClick) {
			this.setState({ menuActive: false });

			if (!this.configMenuClick) {
				this.unblockBodyScroll();
			}
		}

		if (!this.userMenuClick) {
			this.setState({ topbarUserMenuActive: false });
		}

		this.userMenuClick = false;
		this.menuClick = false;
		this.configMenuClick = false;
	}

	onMenuButtonClick(event, isMenuButtonActive) {
		this.menuClick = true;

		if (!this.isHorizontalMenuActive()) {
			this.setState({ menuActive: !isMenuButtonActive }, () => {
				if (this.state.menuActive) {
					this.blockBodyScroll();
				} else {
					this.unblockBodyScroll();
				}
			});
		}

		event.preventDefault();
	}

	onToggleBlockBodyScroll(add) {
		if (add)
			this.blockBodyScroll();
		else
			this.unblockBodyScroll();

		this.configMenuClick = true;
	}

	blockBodyScroll() {
		let className = `blocked-scroll${this.state.horizontal ? '-horizontal-menu' : ''}`;
		if (document.body.classList) {
			document.body.classList.add(className);
		} else {
			document.body.className += ` ${className}`;
		}
	}

	unblockBodyScroll() {
		let className = `blocked-scroll${this.state.horizontal ? '-horizontal-menu' : ''}`;
		if (document.body.classList) {
			document.body.classList.remove(className);
		} else {
			document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
				`${className}`.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		}
	}

	onTopbarUserMenuButtonClick(event) {
		this.userMenuClick = true;
		this.setState({ topbarUserMenuActive: !this.state.topbarUserMenuActive });

		event.preventDefault();
	}

	onTopbarUserMenuClick(event) {
		this.userMenuClick = true;

		if (event.target.nodeName === 'BUTTON' || event.target.parentNode.nodeName === 'BUTTON') {
			this.setState({ topbarUserMenuActive: false });
		}
		event.preventDefault();
	}

	onRootMenuItemClick(event) {
		this.menuClick = true;

		if (this.isHorizontalMenuActive()) {
			this.setState({
				menuActive: !this.state.menuActive
			});
		}
	}

	onMenuItemClick(event) {
		if (!event.item.items) {
			this.setState({ menuActive: false });
			this.unblockBodyScroll();
		}
	}

	onSidebarClick(event) {
		this.menuClick = true;
	}

	isMobile() {
		return window.innerWidth <= 1024;
	}

	isHorizontalMenuActive() {
		return this.state.horizontal && !this.isMobile();
	}

	changeTopbarSize(event) {
		this.setState({ topbarSize: event.size });

		event.originalEvent.preventDefault();
	}

	changeTopbarTheme(event) {
		this.setState({ topbarColor: 'layout-topbar-' + event.color });

		event.originalEvent.preventDefault();
	}

	changeMenuToHorizontal(event) {
		this.setState({ horizontal: event.mode });

		event.originalEvent.preventDefault();
	}

	changeMenuTheme(event) {
		this.setState({ menuColor: 'layout-menu-' + event.color });

		event.originalEvent.preventDefault();
	}

	changeComponentTheme(event) {

		this.setState({ themeColor: event });

		let element = document.getElementById('theme-css');
		let urlTokens = element.getAttribute('href').split('/');
		urlTokens[urlTokens.length - 1] = 'theme-' + event + '.css';
		let newURL = urlTokens.join('/');

		this.replaceLink(element, newURL);

		//	event.originalEvent.preventDefault();

	}

	cambiarColorComponentes() {
		if (this.state.color != null) {
			this.setState({ themeColor: this.state.color });

			let element = document.getElementById('theme-css');
			let urlTokens = element.getAttribute('href').split('/');
			urlTokens[urlTokens.length - 1] = 'theme-' + this.state.color + '.css';
			let newURL = urlTokens.join('/');

			this.replaceLink(element, newURL);
		} else {
			this.setState({ themeColor: 'blue' });

			let element = document.getElementById('theme-css');
			let urlTokens = element.getAttribute('href').split('/');
			urlTokens[urlTokens.length - 1] = 'theme-' + 'blue' + '.css';
			let newURL = urlTokens.join('/');

			this.replaceLink(element, newURL);
		}
	}

	changePrimaryColor(event) {
		this.setState({ layoutColor: event.color });

		let element = document.getElementById('layout-css');
		let urlTokens = element.getAttribute('href').split('/');
		urlTokens[urlTokens.length - 1] = 'layout-' + event.color + '.css';
		let newURL = urlTokens.join('/');

		this.replaceLink(element, newURL);

		event.originalEvent.preventDefault();
	}

	isIE() {
		return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent)
	}

	replaceLink(linkElement, href) {
		if (this.isIE()) {
			linkElement.setAttribute('href', href);
		}
		else {
			const id = linkElement.getAttribute('id');
			const cloneLinkElement = linkElement.cloneNode(true);

			cloneLinkElement.setAttribute('href', href);
			cloneLinkElement.setAttribute('id', id + '-clone');

			linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

			cloneLinkElement.addEventListener('load', () => {
				linkElement.remove();
				cloneLinkElement.setAttribute('id', id);
			});
		}
	}

	createMenu() {
		let { menu } = this.state;
		menuServices.obtenerMenu().then((response) => {
			let arregloMenu = response.data;
			for (var i = 0; i < arregloMenu.length; i++) {
				menu.push(arregloMenu[i]);
			}
			this.setState({ menu: menu });
		}).catch((error) => {

		});
	}

	render() {
		let { logo, usuario, errores, confirma, trabajador, validarBotonEnvio, menu } = this.state;
		const pieCambiarContrasena = <div className="ui-dialog-buttonpane p-clearfix">
			<Button label="Aceptar" icon="pi-md-check" onClick={this.cambiarContrasena.bind(this)} />
			<Button label="Cancelar" icon="pi-md-close" className="p-button-danger " onClick={this.resetEstados.bind(this)} />
		</div>;
		const layoutContainerClassName = classNames('layout-container', {
			'layout-menu-horizontal': this.state.horizontal,
			'layout-menu-active': this.state.menuActive && !this.isHorizontalMenuActive(),
			'layout-top-small': this.state.topbarSize === 'small',
			'layout-top-medium': this.state.topbarSize === 'medium',
			'layout-top-large': this.state.topbarSize === 'large'
		}, this.state.topbarColor, this.state.menuColor);

		const AppBreadCrumbWithRouter = withRouter(AppBreadcrumb);

		return (
			<div ref={(el) => this.layoutContainer = el} className={layoutContainerClassName} style={{ backgroundImage: "url('" + `data:image/jpg;base64,${this.state.fondo}` + "')", height: '310px' }} onClick={this.onWrapperClick}>
				<div className="layout-top">
					<AppTopbar topbarUserMenuActive={this.state.topbarUserMenuActive} menuActive={this.state.menuActive}
						onMenuButtonClick={this.onMenuButtonClick} onTopbarUserMenuButtonClick={this.onTopbarUserMenuButtonClick}
						onTopbarUserMenuClick={this.onTopbarUserMenuClick} model={menu} horizontal={this.state.horizontal} onSidebarClick={this.onSidebarClick}
						onRootMenuItemClick={this.onRootMenuItemClick} onMenuItemClick={this.onMenuItemClick} isHorizontalMenuActive={this.isHorizontalMenuActive} logo={this.state.logo} />

					<div className="layout-topbar-separator" />

					<AppBreadCrumbWithRouter />

				</div>

				<div className="layout-content">
					<Route path="/consultareciboquadrum/bienvenido" exact component={Dashboard} />
					<Route path="/consultareciboquadrum/bienvenido/forms" component={FormsDemo} />
					<Route path="/consultareciboquadrum/bienvenido/sample" component={SampleDemo} />
					<Route path="/consultareciboquadrum/bienvenido/data" component={DataDemo} />
					<Route path="/consultareciboquadrum/bienvenido/panels" component={PanelsDemo} />
					<Route path="/consultareciboquadrum/bienvenido/overlays" component={OverlaysDemo} />
					<Route path="/consultareciboquadrum/bienvenido/menus" component={MenusDemo} />
					<Route path="/consultareciboquadrum/bienvenido/messages" component={MessagesDemo} />
					<Route path="/consultareciboquadrum/bienvenido/charts" component={ChartsDemo} />
					<Route path="/consultareciboquadrum/bienvenido/misc" component={MiscDemo} />
					<Route path="/consultareciboquadrum/bienvenido/empty" component={EmptyPage} />
					<Route path="/consultareciboquadrum/bienvenido/utils" component={UtilsDemo} />
					<Route path="/consultareciboquadrum/bienvenido/documentation" component={Documentation} />
					<Route path="/consultareciboquadrum/bienvenido/cfdi" component={Cfdi} />
					<Route path="/consultareciboquadrum/bienvenido/usuario" component={Usuario} />
					<Route path="/consultareciboquadrum/bienvenido/trabajador" component={Trabajador} />
					<Route path="/consultareciboquadrum/bienvenido/cargarcomprobantes" component={SubirCfdi} />
					<Route path="/consultareciboquadrum/bienvenido/subirafil" component={SubirAfil} />
					<Route path="/consultareciboquadrum/bienvenido/expediente" component={Expediente} />
					<Route path="/consultareciboquadrum/bienvenido/consultarrecibos" component={ConsultaReciboTrabajador} />
					<Route path="/consultareciboquadrum/bienvenido/detallerecibos" component={DetalleRecibos} />
					<Route path="/consultareciboquadrum/bienvenido/detalledocumentos" component={DetalleDocumentos} />
					<Route path="/consultareciboquadrum/bienvenido/clientes" component={Cliente} />
					<Route path="/consultareciboquadrum/bienvenido/detalleafil" component={DetalleAfil} />
					<Route path="/consultareciboquadrum/bienvenido/altaimss" component={AltaImss} />
					<Route path="/consultareciboquadrum/bienvenido/miexpediente" component={ConsultarArchivosTrabajador} />

					<Route path="/consultareciboquadrum/bienvenido/administradorUsuario" component={AdministradorUsuario} />


				</div>
				<Growl ref={(el) => this.growl = el} />

				<Dialog visible={this.state.mostrarModalContrasenia} style={{ width: '60%' }} modal={true} header="¡Por seguridad es importante que actualice su contraseña.!" footer={pieCambiarContrasena} onHide={this.cerrarSession.bind(this)}>
					<div className="p-grid">

						<div className="p-col-12 p-md-2">
							<label htmlFor="contrasenia">*Contraseña</label>
						</div>
						<div className="p-col-12 p-md-4">
							<Password id="contrasena" name="usuario.contrasena" className={errores.contrasena ? 'p-error' : ''} value={usuario.contrasena || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
							{errores.contrasena ? <div><br /> <Message severity="error" text={errores.contrasena} /> </div> : null}
						</div>

						<div className="p-col-12 p-md-2">
							<label htmlFor="confirma">*Confirmar Contraseña</label>
						</div>
						<div className="p-col-12 p-md-4">
							<Password id="confirma" name="confirma" className={errores.confirma ? 'p-error' : ''} value={confirma || ''} onChange={(e) => { this.setState({ confirma: e.target.value }) }} style={{ width: '100%' }} />
							{errores.confirma ? <div><br /> <Message severity="error" text={errores.confirma} /> </div> : null}
						</div>
						<div className="p-col-12 p-md-2">
							<label htmlFor="rfc">*RFC</label>
						</div>
						<div className="p-col-12 p-md-4">
							<InputText id="rfc" name="trabajador.rfc" className={errores.rfc ? 'p-error' : ''} value={trabajador.rfc || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
							{errores.rfc ? <div><br /> <Message severity="error" text={errores.rfc} /> </div> : null}
						</div>
						<div className="p-col-12 p-md-2">
							<label htmlFor="curp">*Curp</label>
						</div>
						<div className="p-col-12 p-md-4">
							<InputText id="curp" name="trabajador.curp" className={errores.curp ? 'p-error' : ''} value={trabajador.curp || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
							{errores.curp ? <div><br /> <Message severity="error" text={errores.curp} /> </div> : null}
						</div>


						<div className="p-col-12 p-md-2">
							<label htmlFor="numeroSeguroSocial">*Número de Seguro Social</label>
						</div>
						<div className="p-col-12 p-md-4">
							<InputText id="numeroSeguroSocial" name="trabajador.numeroSeguroSocial" className={errores.numeroSeguroSocial ? 'p-error' : ''} value={trabajador.numeroSeguroSocial || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
							{errores.numeroSeguroSocial ? <div><br /> <Message severity="error" text={errores.numeroSeguroSocial} /> </div> : null}
						</div>

						<div className="p-col-12 p-md-2">
							<label htmlFor="correo">*Correo</label>
						</div>

						<div className="p-col-12 p-md-4">
							<InputText id="correo" name="usuario.correo" className={errores.correo ? 'p-error' : ''} value={usuario.correo || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
							{errores.correo ? <div><br /> <Message severity="error" text={errores.correo} /> </div> : null}
						</div>
						{validarBotonEnvio ?
							<div className="p-col-12 p-md-12">

								<Button label="Enviar codigo de verificacion" icon="pi-md-check" onClick={this.enviarCodigo.bind(this)} />

							</div>
							: null}
						<div className="p-col-12 p-md-2">
							<label htmlFor="codigoConfirmación">*Codigo de confirmación:</label>
						</div>
						<div className="p-col-12 p-md-4">
							<InputText id="codigo" name="usuario.codigo" className={errores.codigo ? 'p-error' : ''} value={usuario.codigo || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
							{errores.codigo ? <div><br /> <Message severity="error" text={errores.codigo} /> </div> : null}
						</div>
						<div className="p-col-12 p-md-4">
							<Recaptcha sitekey="6LePa7UUAAAAABwcnOacAhKLhiTzPWZ8MT-ya6Ok" render="explicit" onloadCallback={this.recaptchaLoad} verifyCallback={this.verificaCapchaCorrecto} />
						</div>



					</div>
				</Dialog>

				<AppConfig topbarColor={this.state.topbarColor} horizontal={this.state.horizontal}
					layoutColor={this.state.layoutColor} menuColor={this.state.menuColor} themeColor={this.state.themeColor}
					topbarSize={this.state.topbarSize} changeTopbarTheme={this.changeTopbarTheme}
					changeMenuToHorizontal={this.changeMenuToHorizontal} changeMenuTheme={this.changeMenuTheme} changeComponentTheme={this.changeComponentTheme}
					changePrimaryColor={this.changePrimaryColor} changeTopbarSize={this.changeTopbarSize} onToggleBlockBodyScroll={this.onToggleBlockBodyScroll} />

				{(!this.isHorizontalMenuActive() && this.state.menuActive) && <div className="layout-mask" />}

				<AppFooter />

			</div>
		);
	}
}

export default AppRespaldoOriginal;
